import { ReferentEnvironment } from "../../../../referent/src/environments/environment";
import { RegularEnvironment } from "../../../../regular/src/environments/environment";
import { SupervisorEnvironment } from "../../../../supervisor/src/environments/environment";

export const Environment = {
  regular: RegularEnvironment,
  referent: ReferentEnvironment,
  supervisior: SupervisorEnvironment
}